export const codeOfTheDay = "1234";

export const hashCode = (s) => {
    let h = 0, l = s.length, i = 0;
    if (l > 0)
        while (i < l)
            h = (h << 5) - h + s.charCodeAt(i++) | 0;
    return h.toString();
};

export const loginEmail = "admin@notariaatelisevisser.nl";

export const loginPassword = "";

export const enterTime = 750;

export const titleColor= "#42a7f5";
export const buttonColor = "#3ce8dc";

export const imageNames = ["voorkant-verder-weg.jpeg", "vergader-ruimte-vanaf-bureau.jpeg", "bureau-elise.jpeg",
    "kerst-openhaard.jpeg", "vergader-ruimte.jpeg"];

export const maxLetters = 100;

export const pseudoTitle = "Lorem ipsum dolor sit amet";
export const pseudoText = "Lorem ipsum dolor sit amet, no nec fugit aperiri, id iisque veritus consetetur pro. Est " +
    "denique inimicus ne. Cum doctus voluptaria ea, has agam contentiones in, prima nusquam blandit in sed. Dico " +
    "error paulo et cum, eu mundi iisque duo. Eu mel iudico putant, usu eu delenit ancillae periculis.\n" +
    "Nibh minimum liberavisse ne nam, sed placerat efficiendi in. Animal meliore assueverit eu eam, id vix ornatus " +
    "propriae consetetur. Eu velit causae quo. Dico vero habeo vis et, apeirian recusabo gubergren vim cu.";

export const events = {
    "Events": [
        {
            "title": "Kerst is om de hoek",
            "text": "Kerst is hier altijd heel leuk, we hebben leuke lichtjes en een mooie kerstboom."
        },
        {
            "title": "Pasen is voor iedereen",
            "text": "Pasen vieren we vollop, omdat we Christelijk zijn en omdat het een enorm mooie betekenis heeft."
        }
    ]
};